import RootState from 'typings/RootState'
import { VendorList } from './types'
import { Event } from '../../types/event'

export const selectDataList = (state: RootState): VendorList =>
  state.adminSettingVendorERC.DataList

export const selectEvent = (state: RootState): Event =>
  state.adminSettingVendorERC.event

export const selectSorting = (state: RootState) =>
  state.adminSettingVendorERC.sorting
